// extracted by mini-css-extract-plugin
module.exports = {"dialogTitle":"BackModal_dialogTitle__2xHON","dialogBody":"BackModal_dialogBody__1uZOA"};